import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import { FC } from 'react';
import { IdentityCheckIntents } from '~/api/types';

interface IntentSelectionProps {
  value: IdentityCheckIntents;
  onChange: (value: IdentityCheckIntents) => void;
  /**
   * Hides the option of talking with an attendant when the business phone the
   * customer came from is not used for support, so that we do not offer
   * something that conversation cannot deliver.
   */
  showSupportOption?: boolean;
}

/**
 * The options are not mutually exclusive: the customer may want to talk with the
 * support, to receive the boletos through WhatsApp, or both. Selecting at least
 * one of them is required to continue, which is enforced by the screen rendering
 * this component.
 */
export const IntentSelection: FC<IntentSelectionProps> = ({ value, onChange, showSupportOption = true }) => {
  return (
    <Box sx={{ textAlign: 'left', mb: 3 }}>
      <Typography variant="body1" fontWeight="bold" sx={{ mb: 1 }}>
        O que você quer fazer?
      </Typography>
      <FormGroup>
        {showSupportOption && (
          <FormControlLabel
            control={
              <Checkbox
                checked={value.wantsSupport}
                onChange={(e) => onChange({ ...value, wantsSupport: e.target.checked })}
              />
            }
            label="Falar com o atendente no WhatsApp"
          />
        )}
        <FormControlLabel
          control={
            <Checkbox
              checked={value.wantsNotifications}
              onChange={(e) => onChange({ ...value, wantsNotifications: e.target.checked })}
            />
          }
          label="Receber o link dos meus boletos no WhatsApp"
        />
      </FormGroup>
    </Box>
  );
};
